<script>
import { mapActions } from 'vuex';

export default {
  props: ['chartId', 'chart', 'traceId', 'trace'],
  data() {
    return {
    };
  },
  computed: {
    downloadStatus() {
      if (this.trace) {
        return this.trace.downloadResponse.status;
      }
      return null;
    },
    downloadResult() {
      if (this.trace) {
        return this.trace.downloadResponse.result;
      }
      return null;
    },
    downloadMsg() {
      if (this.trace) {
        return this.trace.downloadResponse.msg;
      }
      return null;
    },
    alertValue: {
      get() {
        if (this.trace) {
          return this.trace.downloadAlertValue;
        }
        return false;
      },
      set(value) {
        this.updateTrace({
          id: this.traceId,
          updateObj: {
            downloadAlertValue: value,
          },
        });
      },
    },
  },
  methods: {
    ...mapActions('visualization/traces', ['updateTrace']),
  },
};
</script>

<template>
  <b-alert
    :id="`${chartId}-download-alert`"
    v-model="alertValue"
    class="download-alert position-fixed fixed-top rounded mt-5"
    dismissible
  >
    <!--Not completed, displays the msgs from the get call-->
    <div>
      <p v-if="downloadStatus !== 'completed'">
        {{downloadMsg}}
        <b-spinner
          small
          variant="info"
          label="Loading..."
        ></b-spinner>
      </p>
      <!--Completed, and result is not null-->
      <b-btn
        v-if="downloadResult !== null &&
        downloadStatus === 'completed'"
        :href="`${downloadResult.file_url}`"
        variant="link"
      >Click here to download zip file</b-btn>
    </div>
    <!--Completed, too big and result returns null-->
    <div>
      <p v-if="downloadResult === null &&
      downloadStatus === 'completed'">
        {{downloadMsg}}
        <b-icon
          icon="x-circle"
          variant="danger">
        </b-icon>
      </p>
    </div>
  </b-alert>
</template>
<style scoped>
.download-alert {
  position: fixed;
  border: none;
  width: 50%;
  margin: 0 auto;
  z-index: 2000;
  color: black;
  background-color: rgba(209, 236, 241, 0.85);
  text-align: center;
}
</style>
